import {
  CustomerConfig,
  CustomerConfigResponse,
  CustomersApi,
  GetCustomerConfigRequest,
  PlayerDataCustomerConfig,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const getCustomerConfig = async (): Promise<CustomerConfigResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CustomersApi)

  const request: GetCustomerConfigRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
  }

  return await api.getCustomerConfig(request)
}

const patchCustomerConfig = async (
  customerId: string,
  body: CustomerConfig,
): Promise<CustomerConfig> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CustomersApi)
  return await api.patchCustomerConfig({ customerId, customerConfig: body })
}

const getPlayerDataConfig = async (customerId: string): Promise<PlayerDataCustomerConfig> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CustomersApi)
  return await api.getPlayerDataConfig({ customerId })
}

const patchPlayerDataConfig = async (
  customerId: string,
  body: PlayerDataCustomerConfig,
): Promise<PlayerDataCustomerConfig> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CustomersApi)
  return await api.patchPlayerDataConfig({
    customerId,
    playerDataCustomerConfig: body,
  })
}

export const CustomerServiceAPI = {
  getCustomerConfig,
  patchCustomerConfig,
  getPlayerDataConfig,
  patchPlayerDataConfig,
}
